/**
 * "Recordar este dispositivo" del 2FA de municipio: el backend devuelve un
 * token de dispositivo confiable (30 días) cuando el usuario lo pide, y este
 * módulo lo guarda en localStorage para mandarlo en el próximo login.
 *
 * Va en localStorage y NO en sessionStorage a propósito: tiene que sobrevivir
 * al cierre del navegador, ese es todo el punto (el JWT de sesión sí vive en
 * sessionStorage y se borra solo — ver Login.jsx).
 *
 * Se guarda asociado al EMAIL del usuario ({ "<email>": { token, expira } }),
 * no como un token suelto: en una PC compartida de la oficina, si después se
 * loguea OTRA persona, no se le manda el token de la anterior. (El backend
 * igual lo rechaza — el token está atado a un usuario —, pero así ni siquiera
 * se intenta.) Todo va en try/catch: con el almacenamiento bloqueado (modo
 * privado, etc.) simplemente no se recuerda nada y el login sigue funcionando.
 */

const CLAVE = 'dispositivos_confiables';

const normalizar = (email) => String(email || '').trim().toLowerCase();

const vencido = (entrada) => !!entrada.expira && new Date(entrada.expira) < new Date();

function leerTodo() {
  try {
    const crudo = localStorage.getItem(CLAVE);
    const obj = crudo ? JSON.parse(crudo) : {};
    return obj && typeof obj === 'object' && !Array.isArray(obj) ? obj : {};
  } catch {
    return {};
  }
}

function guardarTodo(obj) {
  try {
    localStorage.setItem(CLAVE, JSON.stringify(obj));
  } catch {
    // sin almacenamiento: no se recuerda el dispositivo, nada más.
  }
}

// Token de dispositivo confiable de ese email, o null si no hay o ya venció
// (los vencidos se limpian de paso).
export function obtenerDispositivoConfiable(email) {
  const clave = normalizar(email);
  if (!clave) return null;
  const todo = leerTodo();
  const entrada = todo[clave];
  if (!entrada || !entrada.token) return null;
  if (vencido(entrada)) {
    delete todo[clave];
    guardarTodo(todo);
    return null;
  }
  return entrada.token;
}

export function guardarDispositivoConfiable(email, token, expira) {
  const clave = normalizar(email);
  if (!clave || !token) return;
  const todo = leerTodo();
  todo[clave] = { token, expira: expira || null };
  guardarTodo(todo);
}

export function borrarDispositivoConfiable(email) {
  const clave = normalizar(email);
  if (!clave) return;
  const todo = leerTodo();
  if (todo[clave]) {
    delete todo[clave];
    guardarTodo(todo);
  }
}
